<template>
  <div class="container-fluid">
    <div class="row mt">
      <div class="col w-100" v-if="isEditor > 0">
        <div class="row">
          <ul id="navbarComponent" class="nav nav-tabs w-100">
            <div
              v-for="(markedareaTemplate, index) in markedareaTemplates"
              :key="index"
            >
              <li class="nav-item">
                <a
                  class="nav-link text-center pt-0 pb-0"
                  style="padding: 2px !important;"
                  @click="insertText(markedareaTemplate.text)"
                  ><i class="fas" :class="markedareaTemplate.icon"></i>
                  <p class="small" style="margin-bottom: 4px !important;">
                    {{ markedareaTemplate.name }}
                  </p></a
                >
              </li>
            </div>
            <li class="nav-item nav-right">
              <a
                class="nav-link text-center pt-0 pb-0"
                @click="switchEditMode(false)"
                ><i class="fas fa-times"></i>
                <p class="small">Schliessen</p></a
              >
            </li>
          </ul>
        </div>
        <div class="row">
          <textarea class="w-100" ref="codetextarea" v-model="text" />
        </div>
      </div>
      <div
        class="col w-100"
        v-if="isEditor < 2"
        @click="switchEditMode(true)"
        style="border-radius: 4px; border: 1px solid #00b3ee;min-height: 50px;"
        v-html="markedHtml(text)"
      ></div>
    </div>
  </div>
</template>

<script>
import { markedareaTemplates } from "@/common/constants";
import { markedHtml } from "@/common/utils";
export default {
  name: "markedarea",
  data: function() {
    return {
      isEditor: 0,
      markedareaTemplates: markedareaTemplates,
      markedHtml: markedHtml
    };
  },
  watch: {},
  methods: {
    insert(templateText) {
      this.text = this.text + templateText;
    },
    insertText(templateText) {
      const el = this.$refs.codetextarea;
      let cursorPos = el.selectionEnd; // Get current Position
      this.text =
        this.text.substring(0, cursorPos) +
        templateText +
        this.text.substring(cursorPos);
      cursorPos += templateText.length;
      this.$nextTick(() => el.setSelectionRange(cursorPos, cursorPos));
    },
    switchEditMode(on) {
      if (on) {
        if (this.isEditor == 1) {
          this.isEditor = 2;
        } else {
          this.isEditor = 1;
        }
      } else {
        this.isEditor = 0;
      }
    }
  },
  props: {
    value: String
  },
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
